/* eslint-disable react/destructuring-assignment */
import React from "react";
import { ThemeProvider } from "@material-ui/core/styles";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";

import CssBaseline from "@material-ui/core/CssBaseline";

import { theme } from "./Theme";
import { GlobalCss } from "./defaultCss";

export const ThemeProviderContainer = (props) => {
  const { children } = props;
  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <ThemeProvider
        theme={{
          ...theme,
        }}
      >
        <CssBaseline />
        <GlobalCss />
        {children}
      </ThemeProvider>
    </MuiPickersUtilsProvider>
  );
};
